import {
	GroupFieldConfiguration,
	SelectFieldConfiguration,
} from '../../../api/ConfigApi';
import { FIELD_TYPES } from '../data/constants';
import { DefaultValuesType } from '../types/DefaultValuesType';

const getEmptyGroupFieldValues = (groupField: GroupFieldConfiguration) => {
	const groupFieldValues = {} as DefaultValuesType;
	groupField.fields.forEach((field) => {
		if (
			field.type === FIELD_TYPES.select &&
			(field as SelectFieldConfiguration).repeatable
		) {
			groupFieldValues[field.name] = [];
		} else if (field.type === FIELD_TYPES.media) {
			groupFieldValues[field.name] = [];
		} else {
			groupFieldValues[field.name] = '';
		}
	});
	return groupFieldValues;
};

export default getEmptyGroupFieldValues;
